<template>
  <section class="has-listing-table">
    <uploaded-data-view
      :is-active="isModalActive"
      :data="viewObject"
      :action="action"
      @cancel="cancel"
    />
    <circul8-table
      :records="customerData"
      :fields="columns"
      :tableName="'UploadedData'"
      :saveDataFields="true"
      :usePropRecords="true"
      :listingComponent="true"
      :whichComponent="whichComponent"
      :isCheckable="false"
      :maxTextLength="25"
      @downloadFile="downloadProof"
      @querySet="searchByFilter"
      @loadNextPage="pullNextPage"
      :enableInfiniteScroll="true"
      :allCountries="countries"
      :allCustomers="customers"
      :allUsers="filteredUsers"
      @backendSort="sortData"
      :backendSortingEnabled="true"
      :hasNextData="nextData"
      :hasPreviousData="previousData"
      @clickView="viewModal"
      :routeNext="false"
      :isThreeDot="true"
      :isViewOnly="true"
      :isLoading="isDataLoading"
      @loadPreviousPage="pullPreviousPage"
      @linkableColumn="linkClicked"
    />
    <div class="records-displayed" v-if="totalRecords > 0">
      <span v-if="currentPage * 50 + 50 < totalRecords"
        >displaying {{ currentPage > 1 ? currentPage * 50 - 50 : 0 }} -
        {{
          currentPage > 0
            ? nextPageCursor
              ? currentPage * 50 - 50 + customerData.length
              : totalRecords
            : customerData.length
        }}
        records out of {{ totalRecords }} records</span
      >
      <div v-else>
        <span v-if="currentPage == 0">
          displaying 0 - {{ totalRecords }} records out of
          {{ totalRecords }} records
        </span>
        <span v-else>
          displaying {{ currentPage * 50 - 50 }} - {{ totalRecords }} records
          out of {{ totalRecords }} records
        </span>
      </div>
    </div>
    <b-loading
      :is-full-page="true"
      v-model="isDataLoading"
      :can-cancel="false"
    ></b-loading>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { forkJoin } from "rxjs";
import CustomerProfileDataService from "@/services/CustomerProfileDataService";
import UserDataService from "@/services/UserDataService";
import { Permission } from "../../services/Permissions";
import { AuthService } from "@/services/AuthService";
import Circul8Table from "../../components/Circul8Table.vue";
import AccountCustomerService from "../../services/AccountCustomerService";
import CustomerUploadService from "../../services/CustomerUploadService";
import UtilityMixin from "@/mixins/UtilityMixin";
import scopeMixin from "@/mixins/scopeMixin";
import { UserGroup } from "@/services/UserGroups";
import UploadedDataView from "@/components/Dashboard/UploadedDataView";

// @group Dashboard
export default {
  name: "CustomersListComponent",
  mixins: [UtilityMixin, scopeMixin],
  components: { Circul8Table, UploadedDataView },
  props: {
    name: {
      type: String,
      default: ""
    },
    accountId: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      data: [],
      authService: new AuthService(),
      customerProfileDataService: new CustomerProfileDataService(),
      userDataService: new UserDataService(),
      isModalActive: false,
      trashObject: null,
      whichComponent: "CP",
      customerData: [],
      checkedRows: [],
      externalUsers: [],
      internalUsers: [],
      customers: [],
      customerIds: [],
      users: [],
      filteredUsers: [],
      switchCustomerId: null,
      query: "",
      enableLoadMore: false,
      loadMoreClicked: false,
      lastSortColumn: null,
      lastSortOrder: null,
      nextPageCursor: null,
      PreviousPageCursor: null,
      displayedRecords: 0,
      totalRecords: 0,
      action: null,
      viewObject: {},
      nextData: false,
      previousData: false,
      isDataLoading: true,
      currentPage: 0,
      columns: [
        {
          field: "email",
          label: "Email",
          width: 200,
          searchable: true,
          type: "input",
          filterKey: { email: "" }
        },
        {
          field: "user",
          label: "Uploaded By",
          width: 200,
          searchable: true,
          type: "multiSelectFilter",
          allStatusVals: this.filteredUsers,
          initStatusVals: [],
          multiSelectFilter: true,
          filterKey: { user: [] }
        },
        {
          field: "customer_name",
          label: "Customer Name",
          width: 200,
          searchable: true,
          type: "multiSelectFilter",
          allStatusVals: this.customers,
          initStatusVals: [],
          multiSelectFilter: true,
          filterKey: { customer_name: [] }
        },
        {
          field: "tracker_r_id",
          label: "Reporting Tracker ID",
          searchable: true,
          visible: true,
          type: "input",
          isLink: true,
          filterKey: { tracker_r_id: "" }
        },
        {
          field: "country",
          label: "Country",
          searchable: true,
          width: 150,
          searchKey: "country",
          type: "multiSelectFilter",
          multiSelectFilter: true,
          initStatusVals: [],
          allStatusVals: this.countries,
          filterKey: { country: [] }
        },
        {
          field: "period",
          label: "Period",
          searchable: true,
          width: 150,
          type: "input",
          filterKey: { period: "" }
        },
        {
          field: "stream",
          label: "Stream",
          type: "multiSelectFilter",
          searchable: true,
          visible: true,
          initStatusVals: [],
          allStatusVals: this.containers,
          filterKey: { stream: [] }
        },
        {
          field: "date_of_upload",
          label: "Date of Upload",
          searchable: true,
          width: 250,
          type: "dateField",

          filterKey: { date_of_upload: "" }
        },
        {
          field: "document_replaced",
          label: "Document Replaced",
          searchable: true,
          type: "input",
          filterKey: { document_replaced: "" }
        },
        {
          field: "comments",
          label: "Comment",
          searchable: true,
          width: 250,
          visible: true,
          additionalInfo: true,
          additionalInfoIcon: "mdi  mdi-information",
          additionalInfoFieldName: "additional_info",
          type: "input",
          filterKey: { comments: "" }
        },
        {
          field: "data",
          label: "Data",
          width: 300,
          searchable: true,
          visible: true,
          download: true,
          downloadIcon: "mdi mdi-download",
          type: "input",
          filterKey: { date: "" }
        },
        {
          field: "actions",
          label: "",
          headerClass: "is-actions",
          cellClass: "is-actions",
          visible: true,
          searchable: true,
          type: "actionSearch",
          actionSearch: true,
          filterKey: { actions: "" }
        }
      ],
      accountCustomerService: new AccountCustomerService(),
      customerUploadService: new CustomerUploadService(),
      customerDataService: new CustomerProfileDataService()
    };
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission", "userGroups"]),
    viewObjectName() {
      return this.viewObject;
    }
  },
  mounted() {
    // hide the data field for view only users
    // view only user are not allowed to download uploaded files
    if (this.userGroups.includes(UserGroup.VIEW_ONLY)) {
      const dataIndex = this.find_column_index("data");
      this.columns[dataIndex].download = false;
    }
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
    }

    if (localStorage.getItem("saveUploadedDataFields")) {
      this.columns = JSON.parse(localStorage.getItem("saveUploadedDataFields"));
      // convert date string to object to auto populate in filter for date
      this.convertDateStringToObject();
    }

    if (localStorage.getItem("queryUploadedData")) {
      this.query = `${localStorage.getItem("queryUploadedData")}&`;
    }
    this.fetchCountries();
    this.fetchSchemes();
    this.fetchContainers();
    this.fetchUserData();
    this.fetchCustomerList();
    this.fetchCustomerUploadUsers();
  },
  // watch: {
  // filteredUsers(newValue) {
  //   this.fetchInternalUserData(newValue);
  // }
  // },
  methods: {
    cancel() {
      this.isModalActive = false;
    },
    linkClicked(value) {
      this.$router
        .push({
          name: "reportingtracker.view",
          params: {
            id: value["tracker_id"]
          }
        })
        .catch(error => {
          this.$router.push({
            name: "reportingtracker.view",
            params: { id: value["tracker_id"] }
          });
        });
    },
    convertDateStringToObject() {
      /*
      string dates in local storage need to be converted to object to auto populate in filter
      */
      const dateOfUpload = this.find_column_index("date_of_upload");
      if (this.columns[dateOfUpload].filterKey.date_of_upload.length) {
        this.columns[dateOfUpload].filterKey.date_of_upload[0] = new Date(
          this.columns[dateOfUpload].filterKey.date_of_upload[0]
        );
        this.columns[dateOfUpload].filterKey.date_of_upload[1] = new Date(
          this.columns[dateOfUpload].filterKey.date_of_upload[1]
        );
      }
    },
    // pullNextPage() {
    //   this.loadMoreClicked = true;
    //   this.nextData = true;
    //   if (this.nextPageCursor != null || this.nextPageCursor != undefined) {
    //     this.query = this.nextPageCursor.split("?")[1] + "&";
    //     this.nextPageCursor != this.PreviousPageCursor && !this.isDataLoading
    //       ? this.fetchCustomerDocument(true)
    //       : "";
    //   }
    // },
    pullNextPage() {
      this.previousData = true;
      this.loadMoreClicked = true;
      this.currentPage = this.currentPage + 1;
      const temp = this.nextPageCursor.split("?")[1].split("&");
      const query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      if (this.nextPageCursor != null || this.nextPageCursor != undefined) {
        this.query =
          "&" + query_part.join("&") + "&page=" + (this.currentPage + 1) + "&";
        this.fetchCustomerDocument(true, "next");
      }
    },
    pullPreviousPage() {
      this.nextData = true;
      this.loadMoreClicked = true;
      const temp = this.PreviousPageCursor.split("?")[1].split("&");
      let query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      query_part = [...new Set(query_part)];
      if (this.currentPage == 0 || this.currentPage == 1) {
        this.query = "&" + query_part.join("&") + "&page=1&";
        this.previousData = false;
      } else {
        this.query =
          "&" + query_part.join("&") + "&page=" + this.currentPage + "&";
      }
      this.currentPage =
        this.currentPage > 0 ? this.currentPage - 1 : this.currentPage;
      this.fetchCustomerDocument(true, "prev");
    },
    sortData(field, order) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.previousData = false;
      this.nextData = false;
      // Clear data arrays to force fresh fetch
      this.customerData = [];
      this.data = [];

      // sort should always fetch page 1, so removing page param if exist
      this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");

      if (localStorage.getItem("currentReportDefaultView")) {
        this.currentReportDefaultView = localStorage.getItem(
          "currentReportDefaultView"
        );
      }

      const oldOrderField = "order_field" + "=" + this.lastSortColumn + "&";
      const oldOrderValue = "order_by" + "=" + this.lastSortOrder + "&";
      const newOrderField = "order_field" + "=" + field + "&";
      const newOrderValue = "order_by" + "=" + order + "&";

      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderField,
        newOrderField
      );
      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderValue,
        newOrderValue
      );

      this.displayedRecords = 0;
      this.lastSortColumn = field;
      this.lastSortOrder = order;
      this.fetchCustomerDocument(true);
    },
    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      if (this.query.includes(oldParam)) {
        this.query = this.query.replace(oldParam, newParam);
      } else {
        this.query += newParam;
      }
      return this.query;
    },

    searchByFilter(filterQuery) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.displayedRecords = 0;
      this.query = filterQuery;
      this.currentPage = 0;
      this.previousData = false;
      this.nextData = false;
      // Clear data arrays to force fresh fetch
      this.customerData = [];
      this.data = [];
      if (filterQuery) {
        localStorage.setItem(
          "saveUploadedDataFields",
          JSON.stringify(this.columns)
        );
        localStorage.setItem("queryUploadedData", filterQuery);
      } else {
        localStorage.removeItem("saveUploadedDataFields");
        localStorage.removeItem("queryUploadedData");
      }
      this.customerData.length = 0;
      let query = "";
      // Maintaining sort column & order in separate varaibles instead of this.query as it becomes difficult to replace & maintain
      // sort column & order part of this.query string. We should maintain query params in associative array instead of string
      if (this.lastSortColumn) {
        query += "order_field" + "=" + this.lastSortColumn + "&";
        query += "order_by" + "=" + this.lastSortOrder + "&";
        query += this.query;
      } else {
        query = this.query;
      }
      this.query = query;
      this.fetchCustomerDocument(true);
    },
    checkCheckBox(d) {
      this.checkedRows = d;
    },
    isAdmin() {
      if (this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL)) {
        return true;
      }
      return false;
    },
    hasPermission() {
      if (
        this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) ||
        this.userHasPermission(Permission.CUSTOMER_PROFILE_CHANGE_CAM)
      ) {
        return true;
      }
      return false;
    },
    // update the column for "uploded by" dropdowns
    fetchInternalUserData(newValue) {
      const userIndex = this.find_column_index("user");
      this.columns[userIndex]["allStatusVals"] = newValue;
      for (const user of this.filteredUsers) {
        if (user.is_active == false) {
          user.name = user.name + "(Inactive)";
        }
      }
    },
    fetchCustomerList() {
      this.isDataLoading = true;
      //changed the api as the previous api was taking too much time
      this.customerProfileDataService
        .fetchCustomerList(this.switchCustomerId)
        .subscribe(response => {
          this.customers = response;
          const customerIndex = this.find_column_index("customer_name");
          this.columns[customerIndex].allStatusVals = response;
          this.fetchCustomerDocument(true);
        });
    },
    prepareUploadedMasterData(data) {
      //const data = Object.assign({}, response);
      const customerData = [];
      for (const upload of data) {
        const uploadObj = {};

        uploadObj["id"] = upload["id"];
        uploadObj["email"] = upload["email"] ? upload["email"] : "NA";
        uploadObj["tracker_r_id"] = upload["tracker_r_id"];
        uploadObj["tracker_id"] = upload["tracker_id"];
        uploadObj["data_file_count"] = upload["document_uploaded"].length;
        if (upload["document_uploaded"].length > 0) {
          if (upload["document_uploaded"].length == 1) {
            for (const document of upload["document_uploaded"]) {
              uploadObj["upload"] = document["document"].substring(25);
              uploadObj["data"] = document["document"]
                .substring(document["document"].lastIndexOf("/") + 1)
                .replaceAll("%20", " ");
            }
          } else {
            uploadObj[
              "data"
            ] = `${upload["document_uploaded"].length} files are uploaded`;
          }
        } else {
          uploadObj["upload"] = upload["document"]
            ? upload["document"].substring(25)
            : "";
          uploadObj["data"] = upload["document"]
            ? upload["document"]
                .substring(upload["document"].lastIndexOf("/") + 1)
                .replaceAll("%20", " ")
            : "";
          uploadObj["data_file_count"] = 1;
        }
        uploadObj["user"] = upload["uploaded_by"];
        uploadObj["customer_name"] = upload["customer"];
        uploadObj["country"] = upload["country"];
        uploadObj["period"] = upload["period"];
        uploadObj["stream"] = upload["stream"];
        uploadObj["comments"] = upload["comments"];
        uploadObj["document_uploaded"] = upload["document_uploaded"];
        uploadObj["document_replaced"] = upload["document_replaced"];

        if (upload["lobster_upload"] == true) {
          uploadObj["additional_info"] = upload["email_content"];
        } else {
          uploadObj["additional_info"] = null;
        }
        uploadObj["date_of_upload"] = this.dateToLocalDate(
          upload["updated_at"]
        );
        uploadObj["customer_id"] = upload["customer_id"];
        customerData.push(uploadObj);
      }
      // if (this.loadMoreClicked == true) {
      //   this.customerData.push(...customerData);
      // } else {
      //   this.customerData = customerData;
      // }
      if (this.nextPageCursor == null) {
        this.customerData.push(...customerData);
        this.data.push(...data);
        if (this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
          if (this.currentPage == 1) {
            this.previousData = false;
          }
        } else {
          this.currentPage = this.currentPage - 1;
          this.previousData = false;
        }
      } else {
        this.customerData = customerData;
        this.data = data;
      }

      if (
        this.$route.query.id !== undefined &&
        this.$route.query.id !== "" &&
        !isNaN(this.$route.query.id)
      ) {
        const pos = this.customerData.findIndex(
          e => e.id == this.$route.query.id
        );

        if (pos >= 0) {
          const lastUpdatedRecord = this.customerData[pos];
          lastUpdatedRecord.lastUpdated = true;
          // remove the last updated record
          this.customerData.splice(pos, 1);
          // add it back to the top
          this.customerData.splice(0, 0, lastUpdatedRecord);
        }
      }
      this.isDataLoading = false;
    },
    fetchCustomerUploadUsers() {
      this.customerUploadService
        .getCustomerUploadUsers(this.switchCustomerId)
        .subscribe(
          response => {
            this.filteredUsers = response;
            const userIndex = this.find_column_index("user");
            this.columns[userIndex].allStatusVals = response;
          },
          e => {
            console.log(e);
          }
        );
    },
    fetchCustomerDocument(initialLoad = false, scrollDir) {
      this.isDataLoading = true;
      this.customerUploadService
        .getAll(this.switchCustomerId, false, this.query)
        .subscribe(
          response => {
            this.PreviousPageCursor = this.nextPageCursor
              ? this.nextPageCursor
              : this.PreviousPageCursor;
            this.nextPageCursor = response["next"];
            if (this.currentPage > 1) {
              this.previousData = true;
              if (this.nextPageCursor != null) {
                this.enableLoadMore = this.nextData = true;
              } else {
                this.enableLoadMore = this.nextData = false;
              }
            } else {
              this.enableLoadMore = this.previousData = false;
              if (this.nextPageCursor != null) {
                this.enableLoadMore = this.nextData = true;
              } else {
                this.enableLoadMore = this.nextData = false;
              }
            }
            this.totalRecords = response["count"];
            let tempData = [];
            if (scrollDir == "next") {
              if (!this.nextPageCursor) {
                this.prepareUploadedMasterData(response["results"]);
              } else {
                tempData = [...this.data, ...response["results"]];
                if (tempData.length > 100 && this.nextPageCursor != null) {
                  tempData = tempData.slice(50, 150);
                }
                this.prepareUploadedMasterData(tempData);
              }
            } else if (scrollDir == "prev") {
              if (this.currentPage == 0) {
                this.prepareUploadedMasterData(response["results"]);
              } else {
                tempData = [...response["results"], ...this.data];
                if (tempData.length >= 100) {
                  tempData = tempData.slice(0, 100);
                }
                this.prepareUploadedMasterData(tempData);
              }
            } else {
              this.prepareUploadedMasterData(response["results"]);
            }
          },
          e => {
            console.log(e);
          }
        );
    },
    filterScheme(countryId) {
      this.schemeDataService.getByCountry(countryId).subscribe(
        response => {
          this.schemes = response;
        },
        e => {
          console.log(e);
        }
      );
    },
    filterStream(schemeId) {
      this.schemeDataService.get(schemeId).subscribe(
        response => {
          this.containers = response["container"];
          this.containers = this.containers.filter(e => e.name !== "General");
        },
        e => {
          console.log(e);
        }
      );
    },
    downloadProof(data) {
      try {
        this.customerUploadService.exportCustomerUpload(
          data.id,
          data.data,
          data.customer_id
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Download Error !",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    viewModal(viewObject) {
      this.action = "View";
      this.viewObject = viewObject;
      this.isModalActive = true;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
